import React, { useRef, useState, useEffect } from "react";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import { emailSignature } from "../../../backend/Server/HelperFunctions/EmailSignatrure";
import ArrowLeft from "../../DesignSystem/Arrows/ArrowLeft";
import ArrowRight from "../../DesignSystem/Arrows/ArrowRight";
import ButtonYellow from "../../DesignSystem/Buttons/ButtonYellow";
import ButtonGreen from "../../DesignSystem/Buttons/ButtonGreen";
import { generateStyledEmailTemplate } from "./GenerateStyledEmailTemplate";
import { fetchWithFallback } from "../../../utils/fetchWithFallback";

const EmailPreviewModal = ({ previews = [], onClose, onUpdate, endpoint }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [emailContent, setEmailContent] = useState("");
  const emailRef = useRef(null);
  const timestamp = new Date().toISOString();
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  useEffect(() => {
    if (previews[currentIndex]) {
      const styled = wrapStyled(
        previews[currentIndex].subject,
        previews[currentIndex].body
      );
      setEmailContent(styled);
    }
  }, [currentIndex, previews]);

  const wrapStyled = (subject, body) => {
    return generateStyledEmailTemplate(body);
  };

  const handleInput = (e) => {
    const selection = window.getSelection();
    if (!selection.rangeCount) return;

    const range = selection.getRangeAt(0);
    const preCaretRange = range.cloneRange();
    preCaretRange.selectNodeContents(emailRef.current);
    preCaretRange.setEnd(range.startContainer, range.startOffset);
    const preCaretPosition = preCaretRange.toString().length;

    setEmailContent(e.currentTarget.innerHTML);

    requestAnimationFrame(() => {
      if (!emailRef.current) return;

      const newRange = document.createRange();
      const sel = window.getSelection();
      let charCount = 0;
      let found = false;

      const restoreCursor = (node) => {
        if (found || !node) return;
        if (node.nodeType === Node.TEXT_NODE) {
          const nextCharCount = charCount + node.textContent.length;
          if (preCaretPosition <= nextCharCount) {
            newRange.setStart(node, preCaretPosition - charCount);
            found = true;
          }
          charCount = nextCharCount;
        } else {
          node.childNodes.forEach(restoreCursor);
        }
      };

      restoreCursor(emailRef.current);

      if (found) {
        newRange.collapse(true);
        sel.removeAllRanges();
        sel.addRange(newRange);
      }
    });

    if (onUpdate) {
      onUpdate(currentIndex, e.currentTarget.innerHTML);
    }
  };

  const handlePrev = () =>
    setCurrentIndex((prev) => (prev === 0 ? previews.length - 1 : prev - 1));

  const handleNext = () =>
    setCurrentIndex((prev) => (prev === previews.length - 1 ? 0 : prev + 1));

  return (
    <div className="AdviserEmailPreviewPopupBackgroundContainer">
      <div className="AdviserEmailPreviewPopup">
        <div className="AdviserDashboardColumn">
          <h2>
            Preview {currentIndex + 1} of {previews.length}
          </h2>
          <p className="Content">
            <strong>Name:</strong> {previews[currentIndex]?.name || ""} <br />
            <strong>Recepient:</strong>{" "}
            {previews[currentIndex]?.emailAddress || ""}
          </p>
          <p className="Content">
            <strong>Subject:</strong> {previews[currentIndex]?.subject || ""}{" "}
            <br />
          </p>
        </div>
        <CloseIcon className="close-icon" onClick={onClose} />

        <div className="AdviserDashboardSmallRow">
          <ArrowLeft onClick={handlePrev} buttonText="&laquo; Previous" />
          <div className="AdviserDashboardColumn">
            {/* <div className="Content">{previews[currentIndex]?.subject}</div> */}
            <div
              ref={emailRef}
              contentEditable
              className="EmailHolder"
              dangerouslySetInnerHTML={{ __html: emailContent }}
              onInput={handleInput}
              suppressContentEditableWarning
            />
          </div>
          {/* <ArrowLeft
              className="arrow-left"
              onClick={handlePrev}
                style={{ cursor: "pointer" }}
            />
            <ArrowRight
              className="arrow-right"
              onClick={handleNext}
                style={{ cursor: "pointer" }}
            /> */}

          <ArrowRight onClick={handleNext} buttonText="Next &raquo;" />
        </div>
        <div className="AlignCenter">
          <ButtonGreen
            buttonText="Send Emails"
            onClick={() => setShowConfirmModal(true)}
            // onClick={() => {
            //   const emailBody = emailRef.current.innerHTML;
            //   const subject = previews[currentIndex].subject;
            //   const email = {
            //     subject,
            //     body: emailBody,
            //     to: previews[currentIndex].emailAddress,
            //     signature: emailSignature,
            //   };
            //   console.log("Email to send:", email);
            // }}
          />
        </div>
        {showConfirmModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <CloseIcon
                className="close-icon"
                onClick={() => setShowConfirmModal(false)}
                // onClick={() => setIsDeleteFileModalOpen(false)}
              />
              <h3>
                {previews.length > 1
                  ? `Are you sure you want to send all ${previews.length} reference
                requests?`
                  : `Are you sure you want to send this reference request?`}
              </h3>
              <div
                className="AdviserDashboardSmallRow"
                style={{ justifyContent: "center", gap: "30px" }}
              >
                <ButtonYellow
                  buttonText="Cancel"
                  onClick={() => setShowConfirmModal(false)}
                />
                <ButtonGreen
  buttonText="Yes, Send Now"
  onClick={async () => {
    try {await fetchWithFallback(endpoint, {
      method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            emailPreviews: previews, 
          }),
        }
      );

      setShowConfirmModal(false);
      onClose();
    } catch (error) {
      // console.error("Failed to send emails", error);
    }
  }}
/>

              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailPreviewModal;
